import React from 'react';

import { Text } from '@betterment/samba-react';
import { formatNumberWithDecimals } from '@betterment/shared-components';

export const PercentText: React.FC<{ percent: number; precision?: number }> = ({ percent, precision = 2 }) => {
  return <Text>{formatNumberWithDecimals(percent, precision)}%</Text>;
};
